'use strict';

// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger

if (!Number.isInteger) {
    Number.isInteger = function numberIsInteger(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
}
//# sourceMappingURL=Number.isInteger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pixi.js/lib/polyfill/Number.isInteger.js
// module id = 605
// module chunks = 213534597649335